import { Instagram, ArrowUpRight } from "lucide-react";
import { CONTACT, GALLERY } from "../../data";
import { Reveal } from "./Reveal";

export default function InstagramFeed() {
  const tiles = [...GALLERY, ...GALLERY].slice(0, 6);
  return (
    <section id="instagram" className="relative bg-secondary py-24 md:py-36" data-testid="instagram">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <Reveal className="lg:col-span-5">
            <p className="text-xs md:text-sm tracking-[0.25em] uppercase text-royal font-semibold mb-5">A nossa montra</p>
            <h2 className="font-display font-extrabold text-ink tracking-tight text-4xl md:text-6xl leading-[1.02] mb-6">
              Siga-nos no<br /><span className="font-serif-ed italic font-medium text-royal">Instagram.</span>
            </h2>
            <p className="text-muted-foreground md:text-lg max-w-md mb-8">
              É onde partilhamos o dia a dia: novos trabalhos, bastidores e a diferença de um vidro impecável. A nossa principal janela para o mundo.
            </p>
            <a href={CONTACT.instagram} target="_blank" rel="noreferrer" className="group inline-flex items-center gap-3 rounded-full bg-ink text-white font-semibold px-7 h-14 hover:bg-royal transition-colors" data-testid="instagram-follow-btn">
              <Instagram size={20} /> {CONTACT.instagramHandle}
              <ArrowUpRight size={18} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
          </Reveal>

          <Reveal delay={0.15} className="lg:col-span-7">
            <div className="grid grid-cols-3 gap-3 md:gap-4">
              {tiles.map((t, i) => (
                <a key={i} href={CONTACT.instagram} target="_blank" rel="noreferrer" className="group relative aspect-square overflow-hidden rounded-xl" data-testid={`instagram-tile-${i}`}>
                  <img src={t.src} alt="Publicação Instagram" loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
                  <div className="absolute inset-0 grid place-items-center bg-royal/0 group-hover:bg-royal/60 transition-colors duration-400">
                    <Instagram size={26} className="text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                  </div>
                </a>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
